import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, change } from 'redux-form'
import PropTypes from 'prop-types'
import TextField from 'material-ui/TextField'

import constants from '../utils/constants'
import fetchJsonp from 'fetch-jsonp'

const renderTextField = ({ input, label, meta: { touched, error }, ...custom }) => (
  <TextField hintText={label}
    floatingLabelText={label}
    errorText={touched && error}
    {...input}
    {...custom}
  />
)

class FederalTaxNumberField extends Component {
  constructor (props) {
    super()

    this.state = {
      federalTaxNumber: ''
    }

    this.handleBlur = this.handleBlur.bind(this);
  }

  mapper (data) {
    return {
      name: data.nome,
      address: data.logradouro,
      number: data.numero,
      neighborhood: data.bairro,
      postalCode: data.cep.replace(/[.-]/g, ''),
      city: data.municipio,
      state: data.uf,
      addressLine: data.complemento,
    }
  }
  handleBlur () {
    const { federalTaxNumber } = this.state
    if (federalTaxNumber) {
      const self = this
      const url = `${constants.ftnUrl}/${federalTaxNumber.replace(/[./-]/g, '')}`

      // eslint-disable-next-line
      fetchJsonp(url)
      .then((response) => response.json())
      .then((response) => {
        const data = self.mapper(response)
        self.props.changeName(data.name)
        self.props.changeTradeName(data.name)
        self.props.changeAddress(data.address)
        self.props.changeNumber(data.number)
        self.props.changeNeighborhood(data.neighborhood)
        self.props.changePostalCode(data.postalCode)
        self.props.changeCity(data.city)
        self.props.changeState(data.state)
      })
      .catch((error) => {
        console.log('Error: ', error)
      })
    }
  }

  render () {
    const { label } = this.props

    return (
      <div>
        <div>
          <Field
            name="federalTaxNumber"
            component={renderTextField}
            label={label}
            onChange={(e, federalTaxNumber) => this.setState({federalTaxNumber})}
            onBlur={this.handleBlur}
          />
        </div>
        <div>
          <Field
            name="name"
            component={renderTextField}
            label="Nome"
            fullWidth={true}
          />
        </div>
        <div>
          <Field
            name="tradeName"
            component={renderTextField}
            label="Nome Fantasia"
            fullWidth={true}
          />
        </div>
        <div>
          <Field
            name="address"
            component={renderTextField}
            label="Logradouro"
            fullWidth={true}
          />
        </div>
        <div>
          <Field
            name="number"
            component={renderTextField}
            label="Número"
            style={{ width: '20%' }}
          />
          <Field
            name="neighborhood"
            component={renderTextField}
            label="Bairro"
            style={{ width: '56%', marginLeft: '2%' }}
          />
          <Field
            name="postalCode"
            component={renderTextField}
            label="CEP"
            style={{ width: '20%', marginLeft: '2%' }}
          />
        </div>
        <div>
          <Field
            name="city"
            component={renderTextField}
            label="Cidade"
            style={{ width: '50%' }}
          />
          <Field
            name="state"
            component={renderTextField}
            label="Estado"
            style={{ width: '48%', marginLeft: '2%' }}
            fullWidth={true}
          />
        </div>
      </div>
    )
  }
}

FederalTaxNumberField.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string
}

export default connect(null, {
  changeName: value => change('record-form', 'name', value),
  changeTradeName: value => change('record-form', 'tradeName', value),
  changeAddress: value => change('record-form', 'address', value),
  changeNumber: value => change('record-form', 'number', value),
  changeNeighborhood: value => change('record-form', 'neighborhood', value),
  changePostalCode: value => change('record-form', 'postalCode', value),
  changeCity: value => change('record-form', 'city', value),
  changeState: value => change('record-form', 'state', value),
})(FederalTaxNumberField)



// WEBPACK FOOTER //
// ./src/components/federalTaxNumberField.js